import Vue from 'vue';
import Vuex from 'vuex';

import user from './modules/user';
import invoice from './modules/invoice';
import signin from './modules/signin';

import { SET_TITLE, SET_VISIBLE_TOP, SET_NAVIGATION_APP, SET_DEBUG, SET_SHARE_WECHAT } from './mutationTypes';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    debug: false,
    title: '',
    visibleTop: true,
    visibleApp: false,
    // 显示顶部打开APP导航的路由
    visbleAppRouters: ['detail'],
    // 隐藏顶部打开APP导航的路由
    hideAppRouters: ['download'],
    // 隐藏tabbar的路由
    hideTopRouters: [],
    shareWechat: false,
  },
  mutations: {
    // 设置标题
    [SET_TITLE](states, newValue) {
      Object.assign(states, { title: newValue });
      document.title = newValue || '';
      setTimeout(() => {
        // 兼容 appWebview监听history模式地址栏改变
        const origin = `${window.location.protocol}//${window.location.host}`;
        if (window.ReactNativeWebView) return window.ReactNativeWebView.postMessage(JSON.stringify({ length: window.history.length }));
        return window.postMessage(JSON.stringify({ length: window.history.length }), origin);
        // window.postMessage(window.history.length);
      });
    },
    // 头部标题栏
    [SET_VISIBLE_TOP](states, newValue) {
      Object.assign(states, { visibleTop: newValue });
    },
    // app导航
    [SET_NAVIGATION_APP](states, newValue) {
      Object.assign(states, { visibleApp: newValue });
    },
    [SET_DEBUG](states, newValue = false) {
      Object.assign(states, { debug: newValue });
    },
    [SET_SHARE_WECHAT](states, newValue = false) {
      console.log(newValue);
      Object.assign(states, { shareWechat: newValue });
    },
  },
  actions: {},
  modules: {
    user,
    invoice,
    signin,
  },
});
